import { createContext, useCallback, useContext, useState } from 'react';
import { CitationReferenceData } from '../../../../../services/reference-generator/types';

export type CitationContextType = {
  activeCitation?: CitationReferenceData;
  setActiveCitation: (citation?: CitationReferenceData) => void;
}

const CitationContext = createContext<CitationContextType>({
  setActiveCitation: () => {},
});

export const useCitationContext = () => useContext(CitationContext);

const CitationProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeCitation, setActiveCitation] = useState<CitationReferenceData | undefined>(undefined);

  const handleSetActiveCitation = useCallback((citation: CitationReferenceData | undefined) => {
    setActiveCitation(citation);
  }, []);

  return (
    <CitationContext.Provider value={{ activeCitation, setActiveCitation: handleSetActiveCitation }}>
      {children}
    </CitationContext.Provider>
  );
};

export default CitationProvider;